import { Award, Lock } from "lucide-react";

const COLORS = { 3: "bg-amber-400", 7: "bg-orange-500", 30: "bg-slate-900 text-amber-400" };

export function BadgeCard({ badge }) {
  return (
    <div
      data-testid={`badge-${badge.id}`}
      className={`rounded-2xl border-2 p-4 flex flex-col items-center text-center gap-2 ${badge.earned ? "bg-white border-orange-300" : "bg-slate-100 border-slate-200 opacity-70"}`}
    >
      <div className={`w-14 h-14 rounded-full grid place-items-center ${badge.earned ? COLORS[badge.days] : "bg-slate-300 text-slate-500"}`}>
        {badge.earned ? <Award className="w-8 h-8" /> : <Lock className="w-6 h-6" />}
      </div>
      <div className="font-display text-lg font-bold uppercase leading-tight">{badge.name}</div>
      <div className="text-xs font-bold text-slate-500">{badge.days} jours d'affilée</div>
    </div>
  );
}
